export const actions = {
    FETCH_BUNDLE_REPOSITORIES: "FETCH_BUNDLE_REPOSITORIES",
};

const initialState = {
    list: [],
};

export default (state = initialState, { type, data }) => {
    switch (type) {
        case actions.FETCH_BUNDLE_REPOSITORIES: {
            return { ...state, list: data };
        }

        default:
            return state;
    }
};
